<script setup>
import SvgIcon from '@/components/base/SvgIcon.vue';

const APPID = import.meta.env.VITE_FACEBOOK_APPID;
const emit = defineEmits(['metaVerify']);
const metaLogin = () => {
    FB.login(function (response) {
        if (response.authResponse) {
            // console.log(response.authResponse);
            // console.log(response.authResponse.accessToken);
            // console.log('Welcome!  Fetching your information.... ');
            window.localStorage.setItem('from-third-party-type', '2');
            const token = response.authResponse.accessToken;
            FB.api('/me', { fields: 'name, email' }, function (response) {
                window.localStorage.setItem('from-third-party-id', response.id);
                emit('metaVerify', token);
                // console.log(response);
            });
        } else {
            //    <!-- If you are not logged in, the login dialog will open for you to login asking for permission to get your public profile and email -->
            console.log('User cancelled login or did not fully authorize.');
        }
    });
};
onMounted(() => {
    (function (d, s, id) {
        var js,
            fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
            return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = 'https://connect.facebook.net/en_US/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');

    window.fbAsyncInit = function () {
        // <!-- Initialize the SDK with your app and the Graph API version for your app -->
        FB.init({
            appId: APPID,
            xfbml: true,
            version: 'v18.0'
        });
        // <!-- If you are logged in, automatically get your name and email adress, your public profile information -->
    };
});
</script>
<template>
    <div class="meta-third-party-card" @click="metaLogin">
        <SvgIcon style="width: 32px; height: 32px" class="md" name="meta" />
    </div>
</template>
<style scoped lang="scss">
.meta-third-party-card {
    cursor: pointer;
}
</style>
